import { useState, useEffect } from 'preact/hooks';
import { MarkdownContent } from '../shared-ui/MarkdownContent';

export function GuidePage() {
  const [content, setContent] = useState<string | null>(null);

  useEffect(() => {
    import('../api/authFetch').then(({ authFetch }) => authFetch('/api/guide'))
      .then((r) => r.json())
      .then((data) => setContent(data.content))
      .catch(() => setContent('# Error\n\nFailed to load the guide.'));
  }, []);

  return (
    <div class="guide-page">
      <div class="guide-header">
        <a href="/" class="guide-back">&larr; Back</a>
        <h1>Agentic Engineering</h1>
        <p class="guide-subtitle">How we use AI agents as first-class collaborators</p>
      </div>
      <div class="guide-content">
        {content === null ? (
          <div style={{ textAlign: 'center', padding: 40, color: '#6666aa' }}>
            <div class="spinner" />
          </div>
        ) : (
          <MarkdownContent text={content} />
        )}
        <div class="guide-footer">
          <p class="guide-credit">
            <a href="https://inctasoft.com" target="_blank" rel="noopener noreferrer">Inctasoft</a>
            {' '}&mdash; a small, family-run team that lives and breathes AI.
          </p>
        </div>
      </div>
    </div>
  );
}
